<template>
  <div class="dropdown-menu-container" ref="dropdownMenu">
    <!-- Header del SuperAdmin -->
    <div class="user-info-container">
      <div class="workspace-user-info user-profile__profile">
          <div class="workspace-user-info__name">
            Panel SuperAdmin
          </div>
      </div>
    </div>
    
    <!-- Resto del menú igual... -->
    <div class="menu-item" @click="navigateToGroupsManagement">
      {{$t('navbar.group-management')}}
    </div>
    
    <div class="menu-item" @click="navigateToCreateGroups">
      {{$t('navbar.course-management')}}
    </div>
    
    <div class="menu-item" @click="navigateToInstitutionsManagement">
      {{ $t('navbar.institution-management') }}
    </div>
    
    <div class="menu-item" @click="navigateToPracticalGuidesManagement">
      {{ $t('navbar.guide-management') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperAdminDropdownMenu',
  methods: {
    navigateToGroupsManagement() {
      if (this.$route.name !== 'groups-management') {
        this.$router.push({ name: 'groups-management' }).catch(() => {});
      }
      this.$emit('close');
    },

    navigateToCreateGroups(){
      if (this.$route.name !== 'create-groups-management'){
        this.$router.push({ name: 'create-groups-management'}).catch(() => {});
      }
      this.$emit('close');
    },

    navigateToInstitutionsManagement() {
      const path = `/${this.$i18n.locale}/educational-institutions-management`;
      if (this.$route.path !== path) this.$router.push(path);
      this.$emit('close');
    },

    navigateToPracticalGuidesManagement() {
      const path = `/${this.$i18n.locale}/practical-guides-management`;
      if (this.$route.path !== path) this.$router.push(path);
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.dropdown-menu-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
  min-width: 100px;
  right: -0.2rem;
  top: -11rem;
}

.user-info-container {
  padding: 18px 15px;
  border-bottom: 1px solid #eee;
  color: white;
  position: relative;
}

.workspace-user-info__name {
  font-size: 16px;
  font-weight: bold;
  color: white;
}

.dropdown-menu-container {
  position: absolute;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 230px;
  width: 100%;
  overflow: hidden;
}

.user-info-container {
  padding: 18px 15px;
  border-bottom: 1px solid #eee;
  color: white;
}

.workspace-user-info {
  display: flex;
  align-items: center;
}

.workspace-user-info__info {
  width: 100%;
}

.workspace-user-info__name {
  font-size: 18px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}

.workspace-user-info__email {
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.9);
}

.menu-item {
  padding: 14px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
  color: #444;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.menu-item:last-child:hover {
  background-color: #f5f5f5;
}
</style>